import React from 'react';
import { AppView } from './RootStep';
import Location from './elements/Location';
import Button from './elements/Button';
import { SelectedAddress } from '../App';
import { BuildingInfo } from '../services/MapIframe';
import RoofSide from './elements/RoofSide';
import { CalculatorUtil } from '../services/CalculatorUtil';
import FactsTable, { FactsTableRow } from './elements/FactsTable';
import TextButton from './elements/TextButton';

interface RoofOverViewProps {
    appView: AppView,
    setAppView: React.Dispatch<AppView>,
    address: SelectedAddress | null,
    buildingInfo: BuildingInfo | null
}

function RoofSidesStep(props: RoofOverViewProps) {

    const backClickHandler = () => {
        props.setAppView(props.appView - 1);
    };

    const handleConfirmClick = () => {
        props.setAppView(AppView.PRODUCTS_SELECTION);
    };

    const segments = props.buildingInfo?.roofSegments
        .map((it, index) => <RoofSide key={index} segment={it} index={index + 1} ></RoofSide> );

    const segmentsCount = CalculatorUtil.getSegmentsCount(props?.buildingInfo);

    const factsTableRows = [
        {title: 'Roof area', value: CalculatorUtil.formatNumber(props.buildingInfo?.totalInCartArea3DM2) + " m²"},
        {title: 'Roof sides', value: segmentsCount}
    ] as FactsTableRow[];

    return <div className="py-8 mx-6">
        <div className="mx-auto text-center">
            <h2 className="text-base font-semibold leading-7 text-cyan-600">THOR DEMO</h2>
            <p className="mt-2 text-2xl font-bold tracking-tight text-gray-900">
                Choose the side or sides of the roof
            </p>
            <div className="mt-2">
                <Location label={props.address?.label} small={true}></Location>
            </div>
        </div>
        <div>
            <ul className="flex flex-col mt-6 lg:max-h-60 2xl:max-h-[600px] overflow-y-scroll">
                {segments}
            </ul>
            <div className={'mt-4'}>
                <FactsTable title="Total" rows={factsTableRows}></FactsTable>
            </div>
        </div>
        <div className="mt-6">
            <Button full={true} onClick={handleConfirmClick} disabled={segmentsCount === 0} text="Confirm"></Button>
            <div className="mt-6">
                <TextButton text="&larr; Back to address selection" onClick={backClickHandler}></TextButton>
            </div>
        </div>
    </div>;

}

export default RoofSidesStep;